import { render, staticRenderFns } from "./CheckinLanguage.vue?vue&type=template&id=56015a7a"
import script from "./CheckinLanguage.vue?vue&type=script&lang=js"
export * from "./CheckinLanguage.vue?vue&type=script&lang=js"
import style0 from "./CheckinLanguage.vue?vue&type=style&index=0&id=56015a7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../and-iot-pre-checkin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports